// extracted by mini-css-extract-plugin
module.exports = {"review-qr-code-dialog":"review-qr-code-dialog-0de49e40cf56d0fbabc066cc853bce10"};